import { render, staticRenderFns } from "./ModelDetails.vue?vue&type=template&id=2f66b392&scoped=true"
import script from "./ModelDetails.vue?vue&type=script&lang=js"
export * from "./ModelDetails.vue?vue&type=script&lang=js"
import style0 from "./ModelDetails.vue?vue&type=style&index=0&id=2f66b392&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f66b392",
  null
  
)

export default component.exports